<mat-button-toggle-group
  [value]="selectedTab$ | async"
  (change)="setSelectedTab($event.value)"
>
  @for (button of buttons; track button) {
    <mat-button-toggle
      class="toolbar-button underlined"
      [value]="button.tabName"
      [matTooltip]="button.tooltip"
    >
      <mat-icon [h3CustomIcon]="button.icon"></mat-icon>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
